export const TEST_ID = 'pageLoaderContainer';
